import initialState from 'redux/modules/customer-slot/state/initial-state';

const reducer = ({ initialLoadComplete }) => ({
  ...initialState,
  initialLoadComplete,
});

export default reducer;
